import { useQuery } from '@tanstack/react-query';
import { fetchCurrencyDropApi } from 'apis/common/commonApis';
import { IDropListProps } from 'utils/types/common';

function useCurrencyDropQuery(word) {
  const { status, data, error, isFetching } = useQuery(
    ['currencyDropData', word],
    async () => await fetchCurrencyDropApi(word),
    {
      select: (data) => {
        const newArr: IDropListProps[] = [];
        data.map((v, i) =>
          newArr.push({
            key: i,
            value: v.currency,
            text: v.origin_name,
          }),
        );
        newArr.push({ key: newArr?.length, value: -1, text: '없음' });
        return newArr;
      },
      onSuccess: (data) => {
        // console.log(data);
      },
    },
  );
  return { status, data, error, isFetching };
}

export default useCurrencyDropQuery;
